export const LoanRoleUserAssignmentFormTestIds = {
  USER_SELECT: 'loan-role-user-assignment-form.user-select',
};
